<template>
  <div>
    <div class="text-left mt-5">
      <b-row>
        <b-col md="4">
          <h5 class="text-primary">
            <b>Message History Log</b>
          </h5>
        </b-col>
        <b-col></b-col>
        <b-col md="6" align="right">
          <b-row>
            <!-- <b-col></b-col> -->
            <b-col md="4"
              ><b-button
                variant="primary"
                @click="modalSendMessage('test', '')"
                block
                size="md"
                >Test</b-button
              ></b-col
            >
            <b-col md="4" class="my-1" align="right">
              <b-form-group label-cols-sm="6" label="Show" class="mb-0 mr-3">
                <b-form-select
                  v-model="perPage"
                  :options="pageOptions"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-input-group style="justify-content: end">
                <b-input-group-text
                  class="bg-white border-right-0"
                  slot="prepend"
                >
                  <img src="@/assets/filter.svg" alt />
                </b-input-group-text>
                <b-dropdown
                  text="Filter Data"
                  variant="light"
                  toggle-class="bg-white border-secondary text-primary border-left-0 pl-0"
                  slot="append"
                >
                  <div class="p-3">
                    <b-row>
                      <b-col md="6">
                        <b-form-group
                          id="fieldset-1"
                          label="Search"
                          class="font-weight-bold"
                          label-for="input-1"
                        >
                          <input
                            placeholder="Search"
                            v-model="search_name"
                            name="search"
                            type="text"
                            data-vv-as="Search"
                            class="form-control"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <b-form-group
                          id="fieldset-1"
                          label="Client Name"
                          class="font-weight-bold"
                          label-for="input-1"
                        >
                          <input
                            placeholder="Client"
                            v-model="client"
                            name="client"
                            type="text"
                            data-vv-as="Client"
                            class="form-control"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <b-form-group
                          id="fieldset-1"
                          label="Create Period"
                          class="font-weight-bold"
                          label-for="input-1"
                        >
                          <b-row>
                            <b-col>
                              <b-row class="m-0">
                                <b-col
                                  class="
                                    pr-0
                                    form-control form-control-sm
                                    img-calender-select
                                    border-right-0
                                  "
                                  md="4"
                                >
                                  <img
                                    src="@/assets/ic-calendar-copy-30.svg"
                                    width="25px"
                                    alt
                                    class="mt-n1"
                                  />
                                </b-col>
                                <b-col md="6" class="px-0">
                                  <datepicker
                                    input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                                    placeholder="Select Date"
                                    v-model="created_at_start"
                                    :format="customFormatter"
                                    :disabledDates="disabledDates"
                                  ></datepicker>
                                </b-col>
                                <b-col align="left" md="1" class="px-0">
                                  <b-col
                                    align="left"
                                    class="
                                      px-4
                                      form-control form-control-sm
                                      del-calender-select
                                      border-left-0
                                    "
                                    md="2"
                                  >
                                    <b-row align="left">
                                      <b-col>
                                        <b-button
                                          class="
                                            m-0
                                            p-0
                                            mt-n1
                                            bg-transparent
                                            border-0
                                          "
                                          @click="resetDateCreatedStart"
                                          variant="outline-light"
                                        >
                                          <i
                                            class="text-danger fas fa-times"
                                          ></i>
                                        </b-button>
                                      </b-col>
                                    </b-row>
                                  </b-col>
                                </b-col>
                              </b-row>
                            </b-col>
                            <b-col>
                              <b-row class="m-0">
                                <b-col
                                  class="
                                    pr-0
                                    form-control form-control-sm
                                    img-calender-select
                                    border-right-0
                                  "
                                  md="4"
                                >
                                  <img
                                    src="@/assets/ic-calendar-copy-30.svg"
                                    width="25px"
                                    alt
                                    class="mt-n1"
                                  />
                                </b-col>
                                <b-col md="6" class="px-0">
                                  <datepicker
                                    input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                                    placeholder="Select Date"
                                    calendar-class="calender-margin"
                                    v-model="created_at_end"
                                    :format="customFormatter"
                                    :disabledDates="disabledDates"
                                  ></datepicker>
                                </b-col>
                                <b-col align="left" md="1" class="px-0">
                                  <b-col
                                    align="left"
                                    class="
                                      px-4
                                      form-control form-control-sm
                                      del-calender-select
                                      border-left-0
                                    "
                                    md="2"
                                  >
                                    <b-row align="left">
                                      <b-col>
                                        <b-button
                                          class="
                                            m-0
                                            p-0
                                            mt-n1
                                            bg-transparent
                                            border-0
                                          "
                                          @click="resetDateCreatedEnd"
                                          variant="outline-light"
                                        >
                                          <i
                                            class="text-danger fas fa-times"
                                          ></i>
                                        </b-button>
                                      </b-col>
                                    </b-row>
                                  </b-col>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <br />
                    <b-row style="text-align-last: right">
                      <b-col>
                        <b-button
                          variant="outline-secondary"
                          @click="resetSearch()"
                          class="mr-3"
                          >Set Ulang</b-button
                        >
                        <b-button variant="primary" @click="search()"
                          >Cari</b-button
                        >
                      </b-col>
                    </b-row>
                  </div>
                  <b-dropdown-item
                    class="pointer-off"
                    style="width: 450px"
                  ></b-dropdown-item>
                </b-dropdown>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <b-row>
        <b-col>
          <section v-if="errored">
            <p>
              We're sorry, we're not able to retrieve this information at the
              moment, please try back later
            </p>
          </section>
          <!-- Main table element -->
          <b-table
            v-else
            show-empty
            hover
            ref="selectableTable"
            responsive="sm"
            stacked="md"
            :items="getInfo"
            :fields="key"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
            head-variant="light"
            class="bg-white"
          >
            <div slot="table-busy" class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
            <template v-slot:head(selected)="data">
              <span class="text-info">
                <b-form-checkbox
                  v-model="allSelected"
                  :indeterminate="indeterminate"
                  aria-describedby="items"
                  aria-controls="items"
                  @change="toggleAll"
                  :value="data"
                ></b-form-checkbox>
              </span>
            </template>
            <template v-slot:cell(selected)="{ rowSelected, item, index }">
              <template v-if="rowSelected">
                <span aria-hidden="true">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="selected_field_true"
                    name="checkbox-1"
                    value="true"
                    class="pointer-off"
                    unchecked-value="false"
                  ></b-form-checkbox>
                </span>
                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                <span aria-hidden="true">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="selected_field_false"
                    name="checkbox-1"
                    value="true"
                    class="pointer-off"
                    unchecked-value="false"
                  ></b-form-checkbox>
                </span>
                <span class="sr-only">Not selected</span>
              </template>
            </template>
            <template v-slot:cell(created_at)="row">
              <label>{{ row.value | DateTime }}</label>
            </template>
            <template v-slot:cell(name)="row">
              <label class="text=primary font-weight-bold">{{
                row.value
              }}</label>
            </template>
            <template v-slot:cell(message)="row">
              <div>
                {{
                  row.value === "" ? "" : row.value.substring(0, 25) + "..."
                }}&nbsp;
              </div>
            </template>
            <template v-slot:cell(action)="{ value, item }">
              <b-link
                v-b-tooltip.hover
                title="View Detail"
                @click="GetDetail(item)"
                class="text-dark"
              >
                <img class="mr-2" src="@/assets/ic-view-detail.svg" alt />
              </b-link>
              <!-- <b-link
                        v-b-tooltip.hover
                        title="Reply"
                        @click="modalSendMessage('reply',item)"
                        class="text-dark"
                    >
                        <img class="mr-2" src="@/assets/ic-edit.svg" alt />
                    </b-link> -->
              <b-link
                v-b-tooltip.hover
                title="Delete"
                class="mr-2"
                @click="del(item)"
              >
                <img src="@/assets/rectangle.svg" alt />
              </b-link>
            </template>
          </b-table>

          <b-row class="mx-auto">
            <b-col md="4" class="mx-auto px-0"
              >Total entries {{ totalRows }}</b-col
            >
            <b-col md="4" class="mx-auto"></b-col>
            <b-col md="4" align="right" class="px-0">
              <b-pagination
                align="right"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <b-modal
      v-model="replyShow"
      id="modal-prevent-closing"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      size="md"
    >
      <h4 class="text-capitalize">
        <b> Message {{ replyCondition }} </b>
      </h4>
      <br />
      <form data-vv-scope="form-send-message">
        <b-row>
          <b-col md="6">
            <b-form-group
              id="input-group-3"
              label="Origin Number"
              label-for="input-3"
              class="mt-3"
            >
              <b-form-select
                id="input-3"
                :disabled="replyCondition == 'reply' ? true : false"
                v-model="testDetail.origin_phone"
                data-vv-as="Origin Number"
                name="origin_phone"
                v-validate="'required'"
              >
                <b-form-select-option :value="null"
                  >Select Origin Number</b-form-select-option
                >
                <b-form-select-option
                  v-for="data in parameter"
                  :key="data"
                  :value="data.phone_display"
                  >{{ data.phone_display }}</b-form-select-option
                >
              </b-form-select>
              <p
                class="text-danger"
                style="width: 100%; margin-top: 0.25rem; font-size: 80%"
              >
                {{ veeErrors.first("form-send-message.origin_phone") }}
              </p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              id="input-group-3"
              label="Phone Number"
              label-for="input-3"
              class="mt-3"
            >
              <b-form-input
                id="input-2"
                :disabled="replyCondition == 'reply' ? true : false"
                v-model="testDetail.customer_phone"
                data-vv-as="Phone Number"
                name="phone_number"
                v-validate="'required|numeric|min:7|max:15'"
                placeholder="Enter Phone Number"
              ></b-form-input>
              <p
                class="text-danger"
                style="width: 100%; margin-top: 0.25rem; font-size: 80%"
              >
                {{ veeErrors.first("form-send-message.phone_number") }}
              </p>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              id="input-group-3"
              label="Client"
              label-for="input-3"
              class="mt-3"
            >
              <b-form-input
                id="input-2"
                :disabled="replyCondition == 'reply' ? true : false"
                v-model="testDetail.client"
                data-vv-as="Client"
                name="client"
                v-validate="'required'"
                placeholder="Enter Client Name"
              ></b-form-input>
              <p
                class="text-danger"
                style="width: 100%; margin-top: 0.25rem; font-size: 80%"
              >
                {{ veeErrors.first("form-send-message.client") }}
              </p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="input-group-3"
              label="Message"
              label-for="input-3"
              class="mt-3"
            >
              <b-form-textarea
                id="textarea"
                v-model="testDetail.message_reply"
                placeholder="Enter Message..."
                rows="3"
                data-vv-as="Message"
                name="message"
                v-validate="'required'"
                max-rows="6"
              ></b-form-textarea>
              <p
                class="text-danger"
                style="width: 100%; margin-top: 0.25rem; font-size: 80%"
              >
                {{ veeErrors.first("form-send-message.message") }}
              </p>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
      <br />
      <b-row>
        <b-col md="6"></b-col>
        <b-col>
          <b-button
            variant="light"
            @click="replyShow = !replyShow"
            class="text-primary"
            block
            size="lg"
            >Batal</b-button
          >
        </b-col>
        <b-col>
          <b-button
            variant="primary"
            :disabled="loadingEmail"
            @click="sendMessage(testDetail)"
            block
            size="lg"
          >
            <b-spinner label="Spinning" v-show="loadingEmail"></b-spinner>Kirim
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      v-model="DetailShow"
      id="modal-prevent-closing"
      style="max-height: 1000px"
      scrollable
      header-class="border-bottom-0"
      footer-class="border-top-0"
      size="md"
    >
      <template v-slot:modal-header>
        <!-- Emulate built in modal header close button action -->
        <h4>
          <b> Detail Message Log </b>
        </h4>
        <b-col style="width: 200px">
          <b-form inline>
            <label>Show&nbsp;</label>
            <b-form-select
              v-model="limitMessage"
              @change="GetDetail(dataDetail)"
              :options="limitMessageOptions"
            ></b-form-select>
          </b-form>
        </b-col>
        <b-col style="width: 100px">&nbsp;</b-col>
        <b-col md="1" class="text-right mr-2"
          ><b-link @click="DetailShow = !DetailShow"
            ><i class="fas fa-times"></i></b-link
        ></b-col>
      </template>
      <b-row style="margin-top: -15px; margin-bottom: -25px">
        <b-col class="p-3 mx-3" style="background-color: #f9f9fb">
          <b-row v-if="loadingDetail">
            <b-spinner label="Spinning"></b-spinner>
          </b-row>
          <b-row
            v-else
            :class="chat.conversation_type == 'origin' ? 'text-right' : ''"
            class="mt-2"
            v-for="chat in detailChat"
            :key="chat"
          >
            <b-col>
              <b-card
                body-class="pb-0"
                :class="
                  chat.conversation_type == 'origin'
                    ? 'color:#827F8E;text-left;'
                    : 'color:#000000'
                "
                :border-variant="chat.error_reason != '' ? 'danger' : ''"
                :style="
                  chat.conversation_type == 'origin'
                    ? 'background-color:#E6E0FF'
                    : 'background-color:#FFFFFF'
                "
                style="
                  min-width: 100px;
                  max-width: 400px;
                  display: inline-block;
                "
              >
                <div>
                  <img
                    v-if="chat.image_url"
                    :src="chat.image_url"
                    width="200px"
                    alt=""
                  />
                </div>
                {{ chat.message }}
                <br />
                <div
                  v-if="chat.error_reason != ''"
                  class="text-danger mt-2"
                  style="margin-right: -12px"
                >
                  <i class="fas fa-exclamation-circle"></i
                  >{{ chat.created_at | Time }}&nbsp;{{ chat.error_reason }}
                </div>
                <div
                  v-else-if="chat.is_sent"
                  class="mt-2"
                  :style="
                    chat.conversation_type == 'origin' ? '' : 'text-align: end;'
                  "
                  style="margin-right: -12px"
                >
                  {{ chat.created_at | Time }}&nbsp;
                  <label
                    v-if="chat.conversation_type == 'origin'"
                    class="mb-0"
                    :style="chat.is_read ? 'color:#5A98E5' : ''"
                  >
                    <i v-if="chat.is_delivered" class="fas fa-check-double"></i>
                    <i v-else-if="chat.is_sent" class="fas fa-check"></i>
                  </label>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <b-form inline style="width: 1000px">
          <textarea
            id="input-2"
            rows="1"
            v-model="dataDetail.message_reply"
            placeholder="Enter Message"
            style="width: 80%"
            class="mr-3 form-control"
            @focus="resizeTextarea"
            @keyup="resizeTextarea"
          ></textarea>
          <b-button
            variant="primary"
            @click="sendMessage(dataDetail)"
            style="width: 17.6%"
            ><i class="fas fa-location-arrow"></i
          ></b-button>
        </b-form>
      </template>
      <br />
    </b-modal>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      DetailShow: false,
      replyShow: false,
      replyCondition: "",
      loading: false,
      loadingCSV: false,
      errored: false,
      loadingDetail: false,
      detailChat: "",
      messageReply: "",
      selected: [],
      created_at_start: new Date(new Date().setDate(new Date().getDate() - 30)),
      created_at_end: new Date(Date.now()),
      client: "",
      key: [
        {
          key: "created_at",
          label: "Date | Time",
          sortable: false,
          class: "text-left w-12",
        },
        {
          key: "origin_phone",
          label: "Origin Number",
          sortable: false,
          class: "text-center w-15",
        },
        {
          key: "customer_phone",
          label: "Customer Number",
          sortable: false,
          class: "text-center w-15",
        },
        {
          key: "client",
          label: "Apps",
          sortable: false,
          class: "text-left w-10",
        },
        {
          key: "message_type",
          label: "Type",
          sortable: false,
          class: "text-center w-10",
        },
        {
          key: "message",
          label: "Message",
          sortable: false,
          class: "text-left",
        },
        {
          key: "action",
          sortable: false,
          label: "",
          class: "text-center w-10",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      limitMessage: 5,
      limitMessageOptions: [5, 10, 25, 50],
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: "",
      CSV: "",
      search_name: "",
      dataDetail: "",
      testDetail: {
        origin_phone: null,
        customer_phone: "",
        client: "",
        message: "",
      },
      customerShow: false,
      selected_field_true: true,
      selected_field_false: false,
      LoadingSendMessage: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      parameter: [],
      default_origin: null,
    };
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch("MessageSettingsModule/getGeneralSettings")
      .then((response) => {
        this.loading = false;
        this.parameter = response.data.data.parameter_app;
      })
      .catch((error) => {
        this.loading = false;
        console.log(error);
      });
  },
  methods: {
    resizeTextarea(e) {
      let area = e.target;
      area.style.overflow = "hidden";
      area.style.height = "auto";
      area.style.height = area.scrollHeight + "px";
      console.log(area.innerHeight);
    },
    resetDateCreatedStart() {
      this.created_at_start = "";
    },
    resetDateCreatedEnd() {
      this.created_at_end = "";
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", this.search_name);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      formData.append("client", this.client);
      formData.append(
        "created_from",
        this.created_at_start != ""
          ? moment(this.created_at_start).format("YYYY-MM-DD")
          : ""
      );
      formData.append(
        "created_to",
        this.created_at_end != ""
          ? moment(this.created_at_end).format("YYYY-MM-DD")
          : ""
      );
      this.$store
        .dispatch("MessageServiceModule/getMessage", formData)
        .then((response) => {
          vm.totalRows = response.data.data.total_record;
          callback(response.data.data.results || []);
          this.loading = false;
        })
        .catch((error) => {
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
    GetDetail(item) {
      this.dataDetail = item;
      this.dataDetail.message_reply = "";
      this.DetailShow = true;
      this.loadingDetail = true;
      const formData = new FormData();
      formData.append("limit", this.limitMessage);
      formData.append("page", 1);
      formData.append("customer_phone", item.customer_phone);
      formData.append("origin_phone", item.origin_phone);
      this.$store
        .dispatch("MessageServiceModule/getMessageDetail", formData)
        .then((response) => {
          this.loadingDetail = false;
          this.detailChat = response.data.data.results.slice().reverse();
        })
        .catch((error) => {
          this.loadingDetail = false;
          console.log(error);
        });
    },
    modalSendMessage(value, item) {
      this.replyShow = true;
      this.replyCondition = value;
      if (item != "") {
        this.testDetail.customer_phone = item.customer_phone;
        this.testDetail.client = item.client;
      } else {
        this.testDetail = {
          origin_phone: null,
          customer_phone: "",
          client: "",
          message_reply: "",
        };
      }
    },
    sendMessage(data) {
      this.$validator.validateAll("form-send-message").then((result) => {
        if (result) {
          const formData = new FormData();
          formData.append("origin_phone", data.origin_phone);
          formData.append("customer_phone", data.customer_phone);
          formData.append("channel", "whatsapp");
          formData.append("client", data.client);
          formData.append("message_type", "text");
          formData.append("message", data.message_reply);
          formData.append("image_url", "");
          formData.append("template_name", "");
          formData.append("params", "");
          this.$store
            .dispatch("MessageServiceModule/sendMessage", formData)
            .then((response) => {
              this.$swal({
                type: "success",
                title: "Your message has been send",
                showConfirmButton: false,
                timer: 1500,
              });
              this.LoadingSendMessage = false;
              this.$refs.selectableTable.refresh();
              this.DetailShow = false;
              this.replyShow = false;
              this.detailChat = response.data.data.results;
            })
            .catch((error) => {
              this.DetailShow = false;
              this.replyShow = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            });
        } else {
          this.LoadingSendMessage = false;
          this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },
    del(data) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          var payload = {
            origin_phone: data.origin_phone,
            customer_phone: data.customer_phone,
          };
          this.$store
            .dispatch("MessageServiceModule/delMessageDetail", payload)
            .then((response) => {
              this.$refs.selectableTable.refresh();
              this.$swal("Deleted!", "Your file has been deleted.", "success");
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(error);
            });
        }
      });
    },
    resetSearch() {
      this.$refs.selectableTable.refresh();
      this.created_at_start = "";
      this.created_at_end = "";
      this.client = "";
      this.search_name = "";
    },
    search() {
      this.$refs.selectableTable.refresh();
    },
  },
};
</script>

<style>
.calender-margin {
  margin-left: -163px;
}
</style>